// extracted by mini-css-extract-plugin
export var avatarContainer = "_ie-0";
export var avatarTypingWave = "_ie-i";
export var gray = "_ie-f";
export var green = "_ie-c";
export var icon = "_ie-9";
export var image = "_ie-1";
export var lg = "_ie-6";
export var md = "_ie-5";
export var presenceDot = "_ie-b";
export var red = "_ie-d";
export var sm = "_ie-4";
export var status = "_ie-a";
export var typingDot = "_ie-h";
export var typingPill = "_ie-g";
export var xl = "_ie-7";
export var xs = "_ie-3";
export var xxl = "_ie-8";
export var xxs = "_ie-2";
export var yellow = "_ie-e";